import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ReactEditor, useSlate } from 'slate-react';
import { Editor, Range } from 'slate';

import {
  SLATE_NODE_TYPES,
  SLATE_TEXT_FORMATS,
  TEXT_ALIGN_TYPES,
} from '../../../const';
import {
  getNodeType,
  isBlockActive,
  isLinkActive,
  isMarkActive,
} from '../../../utils';
import { ToggleFormatButton } from './ToggleFormatButton';
import useStyles from '../useStyles';

export const ToolbarFormatActions = ({
  buttonFormatsToDisplay,
  wrapperComponent: WrapperComponent = Fragment,
  isLabelVisible,
  classes,
  wrapperProps,
}) => {
  const styles = useStyles();
  const editor = useSlate();

  const getIsFormatActive = useCallback(
    (format) => {
      const formatType = getNodeType(format);
      switch (formatType) {
        case SLATE_NODE_TYPES.BLOCK:
          return isBlockActive(
            editor,
            format,
            TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
          );
        case SLATE_NODE_TYPES.MARK:
          return isMarkActive(editor, format);
        case SLATE_NODE_TYPES.INLINE:
          return isLinkActive(editor);
        default:
          return false;
      }
    },
    [editor]
  );

  const getIsFormatDisabled = useCallback(
    (format) => {
      if (format === SLATE_TEXT_FORMATS.LINK) {
        return !(
          editor.selection &&
          ReactEditor.isFocused(editor) &&
          !Range.isCollapsed(editor.selection) &&
          Editor.string(editor, editor.selection).trim()
        );
      }
      return false;
    },
    [editor]
  );

  return buttonFormatsToDisplay.map((format) => {
    return (
      <WrapperComponent key={format} {...wrapperProps}>
        <ToggleFormatButton
          format={format}
          disabled={getIsFormatDisabled(format)}
          className={cx(styles.formatButton, {
            [styles.formatActive]: getIsFormatActive(format),
            [styles.formatButtonWithLabel]: isLabelVisible,
          })}
          isLabelVisible={isLabelVisible}
          classes={classes}
        />
      </WrapperComponent>
    );
  });
};

ToolbarFormatActions.propTypes = {
  buttonFormatsToDisplay: PropTypes.arrayOf(PropTypes.string),
  wrapperComponent: PropTypes.node,
  isLabelVisible: PropTypes.bool,
  classes: PropTypes.shape({}),
};

ToolbarFormatActions.defaultProps = {
  buttonFormatsToDisplay: [],
  isLabelVisible: false,
  classes: null,
};
